<template>
    <div class="form-msg">
        <p class="form-msg-item" v-for="(item,index) in formMsgData">
            <span class="form-msg-label">{{multyLang&&multyLang[item.label]?multyLang[item.label][currentTranslateCode]:item.value}}:</span>
            <template v-if="item.type=='checkbox'&&item.value&&item.value.length>0">
                <template v-for="(ii,jj) in item.value">
                    {{multyLang&&multyLang[ii] ? multyLang[ii][currentTranslateCode]:ii}}
                </template>

            </template>

            <template v-else-if="item.type=='multipleText'&&item.value&&item.value.length>0">
                <template v-for="(ii,jj) in item.value">
                    {{multyLang&&multyLang[ii] ? multyLang[ii][currentTranslateCode]:ii}}
                </template>
            </template>


            <template v-else-if="item.type=='date'&&item.value">
                {{new Date(Number(item.value)).format('yyyy/MM/dd')}}
            </template>

            <template v-else-if="item.type=='datetime'&&item.value">
                {{new Date(Number(item.value)).format('yyyy/MM/dd hh:mm:ss')}}
            </template>

             <template v-else>
                <span class="form-msg-value" v-if="item.value">{{multyLang&&multyLang[item.value] ? multyLang[item.value][currentTranslateCode]:item.value}}</span>
                <span class="form-msg-value" v-if="!item.value">-</span>
            </template>

        </p>
    </div>
</template>

<script>
    import {mutations,store} from "../store";

    export default {
        name:"formMsg",
        props:{
            formMsg:{
                type:Object,
                default(){
                    return{}
                }
            }
        },

        computed:{
            multyLang(){
                return store.multyLang
            },
            currentTranslateCode(){
                return store.currentTranslateCode
            },
        },


        data(){
            return{
                formMsgData:null,
                type:''
            }
        },
        created(){
            let _this = this;
            this.formMsgData = JSON.parse(this.formMsg.data);
        }
    }

</script>

<style lang="scss">
    .form-msg{
        font-size: 14px;
        .form-msg-label{
            margin-right:10px;
        }
        .form-msg-value{

        }
        .form-msg-item{
            margin-top: 5px;
        }

    }
</style>
